import { render, staticRenderFns } from "./deposit-type-list.vue?vue&type=template&id=b42a9094&scoped=true&"
import script from "./deposit-type-list.vue?vue&type=script&lang=js&"
export * from "./deposit-type-list.vue?vue&type=script&lang=js&"
import style0 from "./deposit-type-list.vue?vue&type=style&index=0&id=b42a9094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42a9094",
  null
  
)

export default component.exports